import { useCallback } from "react";
import { useOrgChartContext } from "src/components/OrgChart/context/OrgChartContext";
import { ACTION_TYPES } from "src/components/OrgChart/context/actionTypes";

export const useUpdateTeamTagsCache = (teamId) => {
  const { dispatch } = useOrgChartContext() || {};

  const updateTeamTagsCache = useCallback(
    (tags) => {
      if (!teamId) {
        return;
      }

      dispatch({
        type: ACTION_TYPES.UPDATE_TEAM_TAGS,
        payload: {
          teamId,
          tags,
        },
      });
    },
    [teamId, dispatch]
  );

  return { updateTeamTagsCache };
};
